import {
  Box, Button, ClickAwayListener, Fade, Modal, Paper,
} from '@mui/material'
import UseTranslation from '../../../../hooks/UseTranslation'

const MobileView = ({
  children,
  popperStatus,
  handleClose,
}) => {
  const { t } = UseTranslation()

  return (
    <Modal
      open={popperStatus}
      onClose={handleClose}
      sx={styles.modalBackdrop}
    >
      <Fade in={popperStatus}>
        <Box sx={styles.modalContent}>
          <Paper sx={styles.popperPaper} onClick={handleClose}>
            <ClickAwayListener onClickAway={handleClose}>
              <Box sx={styles.xsPopper}>
                {children}
                <Button onClick={handleClose} sx={styles.closeButton}>
                  {t?.Close}
                </Button>
              </Box>
            </ClickAwayListener>
          </Paper>
        </Box>
      </Fade>
    </Modal>
  )
}

const styles = {
  popperPaper: {
    borderRadius: '12px',
  },
  xsPopper: {
    position: 'fixed',
    bottom: 0,
    right: 0,
    left: 0,
    minHeight: '100px',
    backgroundColor: '#FFFFFF',
    padding: '10px 25px 25px',
    borderRadius: '12px 12px 0 0',
  },
  closeButton: {
    width: '100%',
    height: '40px',
    color: 'info.light',
    fontSize: '14px',
    backgroundColor: 'primary.main',
    borderRadius: '12px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'primary.main',
    },
  },
  modalBackdrop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1300,
    width: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  modalContent: {
    outline: 'none',
  },
}

export default MobileView
